// Vendor imports
const { connect } = require('react-redux')
const { createSelector } = require('reselect')
// Entry imports
const authActions = require('./actions')
const AuthSection = require('./component-dumb')

function mapStateToProps(state) {
  return {
    downloadHref: hrefSelector(state),
    isAndroid: isAndroidSelector(state),
    isIos: isIosSelector(state),
    isMobile: isMobileSelector(state)
  }
}

const mapDispatchToProps = {
  onSocialProviderAuth: authActions.socialAuth,
  onAppDownload: authActions.appDownload
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  AuthSection
)

const isAndroidSelector = createSelector(
  [
    state => state.env.browser
  ],
  (browser) => {
    return Boolean(
      browser.get('android')
    )
  }
)

const isIosSelector = createSelector(
  [
    state => state.env.browser
  ],
  (browser) => {
    return Boolean(
      browser.get('ios')
    )
  }
)

const isMobileSelector = createSelector(
  [
    state => state.env.browser
  ],
  (browser) => {
    return Boolean(
      browser.get('isMobile')
    )
  }
)

const hrefSelector = createSelector(
  [
    state => state.env.deeplinkUrls,
    isAndroidSelector,
    isIosSelector
  ],
  (deeplinks, isAndroid, isIos) => {
    if (isAndroid) {
      return deeplinks.get('android')
    }
    if (isIos) {
      return deeplinks.get('ios')
    }
  }
)
